import React, { useState, useEffect } from 'react'
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { useParams } from "react-router-dom";
import { visualizar } from '../../../../util/AcessoApi'
var format = require('xml-formatter');


export default props => {
    let { id } = useParams();
    const [dados, setDados] = useState()

    useEffect(() => {
        visualizar('/atendimento/prestadorconselhoprof', id,
            obj => {

                setDados(obj.id ? {
                    id,
                    modulo: props.modulo,
                    titulo: 'Cadastro Prestador Conselho Profissional',
                    grupos: [
                        {
                            titulo: 'Dados Gerais',
                            colunas: [
                                { titulo: 'Código', descricao: obj?.id, tamanho: 'col-lg-4' },
                                { titulo: 'Prestador', descricao: obj?.prestador?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Conselho Profissional', descricao: obj?.conselho_profissional.label, tamanho: 'col-lg-4' },
                                { titulo: 'Estado', descricao: obj?.estado?.label, tamanho: 'col-lg-4' },
                                { titulo: 'Número Registro', descricao: obj?.numero_registro, tamanho: 'col-lg-4' },
                                // { titulo: 'Principal', descricao: obj?.principal == false ? 'Não' : 'Sim', tamanho: 'col-lg-4' },
                                { titulo: 'Data Registro', descricao: obj?.data_registro, tamanho: 'col-lg-4' },
                            ]
                        },
                    ]
                } : { titulo: 'Visualização Prestador Conselho Profissionaliente' })

            })

    }, [id])


    return dados ? <VisualizacaoPadrao data={dados} {...props} /> : null
}
